import {
	SET_CURRENT_PAGE,
	SHOW_HIDDEN_PAGE
} from '../actions/actionTypes'

import {SUBMIT_PAGE} from '../../config/pages'
import {updateObject} from '../../utils/utils'

const initialState = {
	page: SUBMIT_PAGE,
	showHiddenPage: false
}

export default function navigationReducer(state = initialState, action) {
	switch (action.type) {
		case SET_CURRENT_PAGE:
			return updateObject(state, {
				page: action.page
			})
		case SHOW_HIDDEN_PAGE:
			return updateObject(state, {
				showHiddenPage: true
			})
		default:
			return state
	}
}